export default "__VITE_ASSET__DZ8P$WqT__"